import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import {
  DELETE_ENTITY_MUTATION,
  DELETE_USER_ENTITY_MUTATION,
  DELETE_REPORT_ENTITY_MUTATION,
  DELETE_NOTIFICATION_ENTITY_MUTATION,
} from 'src/graphql/deleteEntity/mutation';
import { useMutation } from 'src/graphql';
import { notification } from 'src/components/Notification';
import { EntityDeleteConfirm } from 'src/components/EntityDeleteConfirm';
import { Trans } from 'react-i18next';
import { useActivityCreate } from 'src/hooks/activity';
import s from './DeleteButton.styles';

const DeleteButton = ({ id, resourceName }) => {
  const [confirmActive, setConfirmActive] = useState(false);

  const [deleteMutation] = useMutation(DELETE_ENTITY_MUTATION);
  const [deleteUserEntityMutation] = useMutation(DELETE_USER_ENTITY_MUTATION);
  const [deleteReportEntityMutation] = useMutation(DELETE_REPORT_ENTITY_MUTATION);
  const [deleteNotificationEntityMutation] = useMutation(DELETE_NOTIFICATION_ENTITY_MUTATION);

  const createActivity = useActivityCreate();
  const onDelete = () => {
    setConfirmActive(true);
  };

  const forceRefetch = () => {
    window.location.reload();
  };

  const onDeleteConfirm = async () => {
    let mutation = deleteMutation;
    if (['Role', 'User', 'FilteringRuleGroup'].includes(resourceName)) {
      mutation = deleteUserEntityMutation;
    }
    if (['ReportTemplate'].includes(resourceName)) {
      mutation = deleteReportEntityMutation;
    }
    if (['EmailTemplate', 'Notification'].includes(resourceName)) {
      mutation = deleteNotificationEntityMutation;
    }
    try {
      const response = await mutation({
        variables: {
          resourceName,
          id: +id,
        },
      });
      const responseData = response.data.deleteEntity ||
                           response.data.deleteUserEntity ||
                           response.data.deleteReportEntity ||
                           response.data.deleteNotificationEntity;
      if (responseData?.successful) {
        if (['Role', 'User', 'FilteringRuleGroup', 'ReportTemplate', 'EmailTemplate', 'Notification'].includes(resourceName)) {
          createActivity({
            entityType: resourceName,
            entityId: +id,
            action: 'delete',
          });
        }
        forceRefetch();
      } else {
        notification.error('Unknown error deleting item');
      }
    } catch (e) {
      notification.error(e);
    }
  };

  return (
    <Fragment>
      <s.DeleteButton ghost onClick={onDelete} red sm type="button">
        <Trans>REMOVE</Trans>
      </s.DeleteButton>
      {confirmActive && (
        <EntityDeleteConfirm
          id={id}
          onClose={() => setConfirmActive(false)}
          onSubmit={onDeleteConfirm}
          resourceName={resourceName}
        />
      )}
    </Fragment>
  );
};

DeleteButton.propTypes = {
  id: PropTypes.number.isRequired,
  resourceName: PropTypes.string.isRequired,
};

DeleteButton.defaultProps = {};

export default DeleteButton;
